module.exports = __webpack_public_path__ + "static/media/exukonline_entertainment_systems.8dba9a3e.jpg";